(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lily-product-feed-pro"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initLilyFeed(root) {

    if (!root || root.dataset.lilyFeedReady === 'true') {
      return;
    }

    root.dataset.lilyFeedReady = 'true';

    const tabs =
      Array.from(
        root.querySelectorAll('[data-lily-tab]')
      );

    const panels =
      Array.from(
        root.querySelectorAll('[data-lily-panel]')
      );

    if (!tabs.length || !panels.length) {
      return;
    }


    function activate(tabNumber) {

      tabs.forEach(function (tab) {

        const active =
          tab.dataset.lilyTab === tabNumber;

        tab.classList.toggle(
          'is-active',
          active
        );

        tab.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

      });


      panels.forEach(function (panel) {

        const active =
          panel.dataset.lilyPanel === tabNumber;

        panel.classList.toggle(
          'is-active',
          active
        );

        panel.hidden = !active;

      });

    }


    tabs.forEach(function (tab) {

      tab.addEventListener(
        'click',
        function () {

          activate(
            tab.dataset.lilyTab
          );

        }
      );

    });

  }


  function initAll(scope) {

    const context =
      scope || document;

    context
      .querySelectorAll('[data-lily-feed]')
      .forEach(initLilyFeed);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );

  } else {

    initAll(document);

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAll(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lily-product-nav"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initLilyProductNavigation(scope) {

    const context = scope || document;

    context
      .querySelectorAll('[data-lily-product-nav]')
      .forEach(function (navigation) {

        if (
          navigation.dataset.lilyProductNavReady === 'true'
        ) {
          return;
        }

        navigation.dataset.lilyProductNavReady = 'true';


        const backButton =
          navigation.querySelector('[data-lily-back]');


        if (!backButton) {
          return;
        }


        backButton.addEventListener(
          'click',
          function () {

            const fallbackUrl =
              navigation.dataset.fallbackUrl || '/';


            /*
             * Si llegó a la prenda desde otra página
             * de Lily Fashion:
             *
             * colección → producto
             * ofertas → producto
             * feed → producto
             *
             * regresamos a la página anterior.
             */

            if (document.referrer) {

              try {

                const previousUrl =
                  new URL(document.referrer);


                if (
                  previousUrl.hostname ===
                  window.location.hostname
                ) {

                  window.history.back();

                  return;

                }

              } catch (error) {

                /* Si la URL anterior no puede analizarse,
                   utilizamos el fallback. */

              }

            }


            /*
             * Si el visitante llegó directamente desde:
             *
             * Instagram
             * Facebook
             * TikTok
             * Google
             * WhatsApp
             * enlace compartido
             *
             * lo llevamos al Home de Lily Fashion.
             */

            window.location.href =
              fallbackUrl;

          }
        );

      });

  }


  function bootLilyProductNavigation() {

    initLilyProductNavigation(document);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      bootLilyProductNavigation
    );

  } else {

    bootLilyProductNavigation();

  }


  /*
   * Permite que funcione también
   * dentro del editor visual de Shopify.
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initLilyProductNavigation(
        event.target
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lily-promo-offers"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initializeLilyOffers(root) {

    if (!root || root.dataset.lilyOffersReady === 'true') {
      return;
    }

    root.dataset.lilyOffersReady = 'true';

    const rail =
      root.querySelector('[data-lily-offers-rail]');

    if (!rail) {
      return;
    }

    const previous =
      root.querySelector('[data-lily-offers-prev]');

    const next =
      root.querySelector('[data-lily-offers-next]');

    const progress =
      root.querySelector('[data-lily-offers-progress]');

    const autoplay =
      root.dataset.autoplay === 'true';

    const delay =
      Number(root.dataset.delay) || 4000;

    const reduceMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    function getStep() {

      const card =
        rail.querySelector('.lily-offer-card');

      if (!card) {
        return rail.clientWidth * 0.75;
      }

      const styles =
        window.getComputedStyle(rail);

      const gap =
        parseFloat(styles.gap || 0);

      return (
        card.getBoundingClientRect().width +
        gap
      );

    }


    function move(direction) {

      rail.scrollBy({
        left: getStep() * direction,
        behavior: reduceMotion
          ? 'auto'
          : 'smooth'
      });

    }


    if (previous) {

      previous.addEventListener(
        'click',
        function () {
          move(-1);
        }
      );

    }


    if (next) {

      next.addEventListener(
        'click',
        function () {
          move(1);
        }
      );

    }


    function updateProgress() {

      if (!progress) {
        return;
      }

      const maximum =
        rail.scrollWidth -
        rail.clientWidth;

      if (maximum <= 0) {

        progress.style.width = '100%';

        return;
      }

      const visibleRatio =
        rail.clientWidth /
        rail.scrollWidth;

      const movementRatio =
        rail.scrollLeft /
        maximum;

      const barWidth =
        Math.max(12, visibleRatio * 100);

      progress.style.width =
        barWidth + '%';

      progress.style.transform =
        'translateX(' +
        (
          movementRatio *
          ((100 - barWidth) / barWidth) *
          100
        ) +
        '%)';

    }


    rail.addEventListener(
      'scroll',
      updateProgress,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateProgress
    );

    updateProgress();


    if (!autoplay || reduceMotion) {
      return;
    }


    let timer = null;


    function stopAutoplay() {

      if (timer) {

        window.clearInterval(timer);

        timer = null;

      }

    }


    function startAutoplay() {

      stopAutoplay();

      timer =
        window.setInterval(
          function () {

            const maximum =
              rail.scrollWidth -
              rail.clientWidth;

            if (maximum <= 0) {
              return;
            }

            if (
              rail.scrollLeft >=
              maximum - 10
            ) {

              rail.scrollTo({
                left: 0,
                behavior: 'smooth'
              });

            } else {

              move(1);

            }

          },
          delay
        );

    }


    rail.addEventListener(
      'mouseenter',
      stopAutoplay
    );

    rail.addEventListener(
      'mouseleave',
      startAutoplay
    );

    rail.addEventListener(
      'focusin',
      stopAutoplay
    );

    rail.addEventListener(
      'focusout',
      startAutoplay
    );

    rail.addEventListener(
      'touchstart',
      stopAutoplay,
      { passive: true }
    );

    rail.addEventListener(
      'touchend',
      function () {

        window.setTimeout(
          startAutoplay,
          1600
        );

      },
      { passive: true }
    );


    startAutoplay();

  }


  function initializeAll(scope) {

    const context =
      scope || document;

    context
      .querySelectorAll('[data-lily-offers]')
      .forEach(
        initializeLilyOffers
      );

  }


  function boot() {

    initializeAll(document);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initializeAll(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
